document.addEventListener('DOMContentLoaded', function () {
  console.log('Custom JS is running');
  // Theo dõi cả .product-card-image và các class khác
  const elements = document.querySelectorAll('.product-card-image, .img-zoom-out');
  if (elements.length === 0) {
    console.log('No elements found with specified classes');
  } else {
    console.log('Found', elements.length, 'elements with specified classes');
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          console.log('Element in view:', entry.target.src || entry.target); // src nếu là hình, hoặc element
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.1, // Giảm để dễ kích hoạt
      rootMargin: '0px'
    }
  );

  elements.forEach((element) => {
    observer.observe(element);
    console.log('Observing:', element.src || element);
  });
});


document.addEventListener('DOMContentLoaded', function() {
    // Character counter
    var maxLength = 250;
    var textarea = document.getElementById('message');
    var counter = document.getElementById('rchars');
    
    if (textarea && counter) {
        textarea.addEventListener('input', function() {
            var remaining = maxLength - this.value.length;
            counter.textContent = remaining;
        });
    }

    // Predefined messages
    document.querySelectorAll('.gift-message-buttons button').forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            var message = '';
            
            switch(this.classList[2]) {  // Lấy class thứ 3 (link-1, link-2,...)
                case 'link-1': // Happy Birthday
                    message = "Dear \n \nWishing you the very best birthday and a wonderful year ahead. \n \nMuch love,";
                    break;
                case 'link-2': // Get Well Soon
                    message = "Dear \n\nWishing you a healthy recovery! Hope these flowers brighten up your day. \n\nAll best wishes from,";
                    break;
                case 'link-3': // Condolences
                    message = "Dear \n\nSending our condolences for your loss. \n\nKnow that you and the family are in our thoughts.\n\nWith deepest sympathy,";
                    break;
                case 'link-4': // Anniversary
                    message = "Dear \n\nHappy anniversary! \n\nThank you for another great year and looking forward to creating many, many more memories together. \n\nI love you,";
                    break;
                case 'link-5': // Baby
                    message = "Dear \n\nCongratulations on the arrival of your beautiful newborn baby.\nSending lots of love and excitement to all the family on this joyful occasion.\nMay the blessings continue. \n\nBest Wishes,";
                    break;
            }
            
            textarea.value = message;
            var remaining = maxLength - message.length;
            counter.textContent = remaining;
        });
    });
});



document.addEventListener('DOMContentLoaded', function() {
    // Hàm cập nhật ảnh
    function updateImages() {
        const images = document.querySelectorAll('.jdgm-carousel-item__product-image');
        images.forEach(function(img) {
            // Lấy URL từ data-src hoặc src
            let currentSrc = img.getAttribute('data-src') || img.getAttribute('src');
            if (currentSrc && currentSrc.includes('cdn.shopify.com')) {
                // Xóa phần kích thước (_140x140 hoặc _280x280)
                let originalSrc = currentSrc.replace(/_\d+x\d+\./, '.').split('?')[0];
                if (img.src !== originalSrc) {
                    img.setAttribute('src', originalSrc); // Thay src
                    img.removeAttribute('data-src-retina'); // Xóa retina
                    img.removeAttribute('data-src'); // Xóa data-src để tránh ghi đè
                }
            }
        });

        // Điều chỉnh container
        const items = document.querySelectorAll('.jdgm-carousel-item');
        items.forEach(function(item) {
            item.style.alignItems = 'center';
        });
    }

    // Chạy lần đầu
    updateImages();

    // Theo dõi thay đổi từ Judge.me
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.target.classList.contains('jdgm-carousel-item__product-image')) {
                updateImages();
            }
        });
    });

    // Quan sát container cha
    const targetNode = document.querySelector('.reviews-gallery-content') || document.body;
    observer.observe(targetNode, {
        attributes: true,
        childList: true,
        subtree: true
    });

    // Chạy định kỳ để chắc chắn
    setInterval(updateImages, 1000); // Tăng lên 1 giây để giảm tải
});

// Cập nhật ngày giao hàng
document.addEventListener('DOMContentLoaded', function () {
  const deliveryDateInput = document.getElementById('delivery-date');

  if (deliveryDateInput) {
    deliveryDateInput.addEventListener('change', function () {
      const selectedDate = this.value;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'Delivery Date': selectedDate },
          note: `Delivery Date: ${selectedDate}`
        })
      })
      .then(response => response.json())
      .then(data => console.log('Cart updated:', data))
      .catch(error => console.error('Error:', error));
    });
  }
});

// Xác nhận ngày giao hàng trước khi checkout
function confirmDeliveryDate(event) {
  const deliveryDate = document.getElementById('delivery-date').value;
  if (!deliveryDate) {
    alert('Please select a delivery date before checking out.');
    event.preventDefault(); // Ngăn submit nếu chưa chọn ngày
    return false;
  } else {
    const confirmed = confirm(`Please confirm your delivery date: ${deliveryDate}\nPress OK to proceed to checkout.`);
    if (!confirmed) {
      event.preventDefault(); // Ngăn submit nếu nhấn Cancel
      return false;
    }
    // Không cần event.preventDefault() ở đây, để Shopify xử lý submit tự nhiên khi nhấn OK
    return true;
  }
}